import type { Address } from 'viem'

export enum ChainId {
  Mainnet = 1,
  Optimism = 10,
  Unichain = 130,
  Polygon = 137,
  Worldchain = 480,
  Base = 8453,
  Hyperevm = 999,
  Arbitrum = 42161,
  Plume = 98866,
  Katana = 747474,
  Stable = 988,
  Monad = 143,
  Tempo = 4217,
  Cronos = 25,
  Robinhood = 4663,
  Arc = 5042,
  Sepolia = 11155111
}

export type MaybeChainId = ChainId | string | number

export interface Token {
  address: Address
  decimals: number
  name: string
  symbol: string
  logoUrl?: string
  priceUsd?: number
}

export type WithChainId<T> = T & { chainId: ChainId }
